import React, { useState } from 'react';
import { usePIM } from '../context/PIMContext';
import { Settings, Upload } from 'lucide-react';
import { BASE_UPLOAD_URL } from '../config';

export const MiddlePanel = () => {
    const { charges, activeCharge, setActiveCharge, statuses, productImages } = usePIM();
    const [currentIndex, setCurrentIndex] = useState(0);

    // Reset index when images change
    React.useEffect(() => {
        if (productImages && productImages.length > 0) {
            const mainIndex = productImages.findIndex(img => img.is_main);
            setCurrentIndex(mainIndex !== -1 ? mainIndex : 0);
        } else {
            setCurrentIndex(0);
        }
    }, [productImages]);

    const handleImageClick = (e) => {
        if (!productImages || productImages.length === 0) return;

        const { left, width } = e.currentTarget.getBoundingClientRect();
        const clickX = e.clientX - left;

        if (clickX < width / 2) {
            // Previous
            setCurrentIndex(prev => (prev === 0 ? productImages.length - 1 : prev - 1));
        } else {
            // Next
            setCurrentIndex(prev => (prev === productImages.length - 1 ? 0 : prev + 1));
        }
    };

    const currentImage = productImages && productImages.length > 0 ? productImages[currentIndex] : null;

    return (
        <div className="h-full flex flex-col gap-2">
            {/* Charge Selector */}
            <div className="space-y-0.5">
                <div className="flex justify-between items-center px-1">
                    <span className="text-xs font-bold text-stone-500 uppercase">CHARGE</span>
                    <span className="text-xs text-stone-500">{activeCharge?.id || ''}</span>
                </div>
                <div className="flex gap-2">
                    <select
                        className="flex-1 bg-stone-950 border border-stone-700 rounded px-3 py-1.5 text-sm text-stone-200 focus:outline-none focus:border-blue-600 appearance-none transition-colors"
                        value={activeCharge?.id || ''}
                        onChange={(e) => {
                            const selected = charges.find(c => c.id == e.target.value);
                            if (selected) setActiveCharge(selected);
                        }}
                        style={{
                            borderColor: activeCharge ? statuses.find(s => s.name === activeCharge.status)?.hex_code || '' : '',
                            backgroundColor: activeCharge && statuses.find(s => s.name === activeCharge.status)?.hex_code ? `${statuses.find(s => s.name === activeCharge.status)?.hex_code}20` : ''
                        }}
                    >
                        <option value="" style={{ backgroundColor: '#0c0a09' }}>Select Charge</option>
                        {charges.map(charge => (
                            <option key={charge.id} value={charge.id} style={{ backgroundColor: '#0c0a09' }}>
                                {charge.charge_id} ({charge.status})
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Image Carousel Area */}
            <div
                className="flex-1 bg-transparent rounded-lg flex flex-col items-center justify-center text-stone-500 relative overflow-hidden group select-none"
                onClick={handleImageClick}
                style={{ cursor: productImages?.length > 0 ? 'pointer' : 'default' }}
            >
                {currentImage ? (
                    <div className="w-full h-full p-4 flex items-center justify-center relative">
                        <img
                            src={currentImage.file_path}
                            alt={currentImage.file_name}
                            className="max-w-full max-h-80 object-contain w-auto h-auto"
                        />

                        {/* Navigation Hints (Visible on Hover) */}
                        {/* Navigation Hints (Visible on Hover) - Simplified to just arrows */}
                        <div className="absolute inset-y-0 left-0 w-12 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                            <span className="text-white/70 text-2xl font-bold drop-shadow-md">&lt;</span>
                        </div>
                        <div className="absolute inset-y-0 right-0 w-12 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                            <span className="text-white/70 text-2xl font-bold drop-shadow-md">&gt;</span>
                        </div>

                        {/* Counter */}
                        <div className="absolute bottom-2 right-2 bg-black/50 px-2 py-1 rounded text-xs text-white opacity-0 group-hover:opacity-100 transition-opacity">
                            {currentIndex + 1} / {productImages.length}
                        </div>
                    </div>
                ) : (
                    <div className="flex flex-col items-center justify-center opacity-50">
                        <span className="text-sm font-medium">No images available</span>
                        <span className="text-xs">Upload images in the Pictures tab</span>
                    </div>
                )}
            </div>
        </div>
    );
};
